<div class="iframe-container">
    <iframe src="https://www.monphoenix.fr/qui-sommes-nous/" width="100%" height="100%" frameborder="0"></iframe>
  </div>
  